import React from "react";
import AppColors from "../colors/AppColors";
import FadeLoader from "react-spinners/FadeLoader";

export default function FullScreenLoader() {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            backgroundColor: AppColors.PRIMARY_COLOR
        }}>
            <FadeLoader color={'#FFFFFF'} />
        </div>
    );
}